import type { ReactNode } from 'react';
import { FeedbackProvider, type FeedbackSubmission } from '@babomrs/ui';
import { apiClient } from '@babomrs/api-client';

/**
 * Client-portal feedback mount (Story D2 + F2, Epic #9653). Wraps the authenticated
 * app shell in the shared FeedbackProvider (never on PublicLayout): the persistent
 * widget renders AND the Client Portal Assistant can flag incorrect AI output via
 * useFeedback(). The server derives the submitter from the auth token.
 */
export function ClientFeedbackWidget({ children }: { children: ReactNode }) {
  return (
    <FeedbackProvider
      portal="client"
      submit={async (input: FeedbackSubmission) => {
        const res = await apiClient.post<{ trackingReference: string }>('/api/v1/feedback', input);
        return res.trackingReference;
      }}
    >
      {children}
    </FeedbackProvider>
  );
}
